import styled from "styled-components";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useDispatch } from 'react-redux'
import { useState,useEffect } from 'react'






const Container=styled.div`
	
padding:10px
  `;


export default function AutoSelect(props){
	let { data,id,label,disabled,action } = props;
	let [datos,setDatos] = useState(data);
	let dispatch = useDispatch();

	useEffect(()=>{
		if(data){ setDatos(data) };	
	},[data]);

	let handleChange=(e,newValue)=>{
		if(!newValue){
			dispatch(action(""));
		}else {
      let consolas=[] 
      for (let consola in newValue.value.Consolas){
        if(consola){
          consolas.push(newValue.value.Consolas[consola].id)
        }
      };
      dispatch(action({...newValue.value,Consolas:consolas}))
    }	
	}

return (
  <Container>
    {datos && label === "juegos" ? (
      <Autocomplete
        fullWidth
        clearOnEscape
        size="small"
        disabled={datos && !disabled ? false : true}
        id={id}
        onChange={handleChange}
        options={datos}
        getOptionLabel={(opcion) => opcion.label}
        sx={{ minWidth: 400 }}
        renderOption={(props, option) => (
          <li
            {...props}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span style={{ color: 'white' }}>{option.label}</span> 
            <img
              src={option.value.poster}
              alt={option.value.name}
              style={{
                width: '120px',
                height: '110px',
                objectFit: 'cover',
                marginRight: '10px',
              }}
            />
          </li>
        )}
        renderInput={(params) => <TextField {...params} label={label} />}

        ListboxProps={{
          sx: {
            '&::-webkit-scrollbar': {
                width: '3px', // Anchura de la scrollbar
              },
            '&::-webkit-scrollbar-thumb': {
                background: "#27B0FE",
                borderRadius: "15px"
              },
            '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#555', // Color al pasar el ratón
              },
            '&::-webkit-scrollbar-track': {
                backgroundColor: 'transparent', // Color del track de la scrollbar
              },
          },
        }}
      />
    ) : (
      <Autocomplete
        fullWidth
        clearOnEscape
        size="small"
        disabled={datos && !disabled ? false : true}
        id={id}
        onChange={handleChange}
        options={datos}
        sx={{ width: 400 }}
        renderInput={(params) => <TextField {...params} label={label} />}
      />
    )}
  </Container>
);
}